import portfolio from '../../portfolio'
import './Contact.css'

const Contact = () => {
  const emailContact = portfolio.contact?.find(c => c.type === 'Email')
  if (!emailContact) return null

  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title'>Contact</h2>
      <a href={emailContact.href}>
        <span type='button' className='btn btn--outline'>
          Email me
        </span>
      </a>
    </section>
  )
}

export default Contact
